import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ReclamationLocationsDataGrid } from "src/components/views/erp/reclamation/masterData/ReclamationLocationsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/reclamations/reclamationLocation")({
	staticData: { title: i18n.t("reclamation_locations"), legacyViewKey: "reclamationLocationsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ReclamationLocationsDataGrid />;
}
